export default __webpack_public_path__ + "img/ic-dashboard.3637f077.svg";